import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Dropdown, Menu, Tooltip } from 'antd'
import { Text } from './Text';
import { Button, TextButton, ImageButton } from './Button';
import { Image } from './Image';
import { StyledExtLink, StyledLink } from '../Reusable/Link'
import { addDataToStore, SAVE_DATA, USERDEFAULTS_SAVE_FLAG } from '../../Actions/actions'
import { getUserRoles } from '../../Utils/util'
import { apiPOSTReq } from '../../Utils/api'
import AlertModal from '../Reusable/AlertModal'
import { CardContainer, FlexColumn, Flex } from './Container';
import ModalClose from '../../Images/promo-close.svg'
import Minimize from '../../Images/minimize.svg'
import Aion from '../../Images/aion-promo-logo.png'
import ThumbsUp from '../../Images/thumbs-up.svg';
import environment from '../../environment'


class PromoModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            promoCards: null,
            promoCard: null,
            isAlertVisible: false,
        };
    }

    componentDidMount() {
        this.getPromoCards();
    }

    getPromoCards = () => {
        apiPOSTReq(`${environment.uamBaseUrl}/aion/system/getPromoCardInfo`, {}, {}, (err, resp) => {
            try {
                const data = resp;
                console.log("Home getPromoCardInfo", data);
                if (data.result) {
                    this.setState({
                        promoCards: data.promoCardInfoList,
                        promoCard: this.getNextPromoCard(data.promoCardInfoList), // Set the first promo card
                    });
                } else {
                    throw Error(
                        data.error ||
                        data.responseMessage ||
                        "Sorry we had trouble processing your request. Please try again later"
                    );
                }
            } catch (error) {
                console.log("ERRR getPromoCardInfo", error.stack, resp);
                // ErrorAlert({ description: error.message });
            }
        });
    };

    dismissPromoCard = (promoCardObjectId, minimize = false) => {
        const { aionStore, userDefaults, dispatch } = this.props;
        const { promoCards } = this.state;
        const minimizedPromoCards = aionStore.minimizedPromoCards || [];
        const dismissedPromoCards = userDefaults.dismissedPromoCards || [];

        // Add the dismissed promo card's objectId to the aionStore
        dispatch(
            minimize ? addDataToStore(SAVE_DATA, {
                minimizedPromoCards: [...minimizedPromoCards, promoCardObjectId],
            }) : addDataToStore(USERDEFAULTS_SAVE_FLAG, {
                dismissedPromoCards: [...dismissedPromoCards, promoCardObjectId],
            })
        );

        // Filter out dismissed promo cards
        const availablePromoCards = (promoCards || []).filter(
            (card) => ![...dismissedPromoCards, promoCardObjectId].includes(card.objectId) && ![...minimizedPromoCards, promoCardObjectId].includes(card.objectId)
        );

        // Sort by sequenceNumber to get the earliest card
        availablePromoCards.sort((a, b) => a.sequenceNumber - b.sequenceNumber);

        this.setState({ promoCard: availablePromoCards.length > 0 ? availablePromoCards[0] : null });
    };

    getNextPromoCard = (promoCards) => {
        const { aionStore, userDefaults } = this.props;
        const minimizedPromoCards = aionStore.minimizedPromoCards || [];
        const dismissedPromoCards = userDefaults.dismissedPromoCards || [];

        // Filter out dismissed promo cards
        const availablePromoCards = (promoCards || []).filter(
            (card) => !minimizedPromoCards.includes(card.objectId) && !dismissedPromoCards.includes(card.objectId)
        );

        // Sort by sequenceNumber to get the earliest card
        availablePromoCards.sort((a, b) => a.sequenceNumber - b.sequenceNumber);

        // Set the first available promo card (or null if all have been dismissed)
        return availablePromoCards.length > 0 ? availablePromoCards[0] : null;
    };

    trackPromoCards = () => {
        const { promoCard } = this.state;
        const { aionStore } = this.props;
        const { UserInfo, business } = aionStore;

        const { businessProfile } = business
        const { businessInfo } = businessProfile

        this.setState({ loading: true })

        const body = {
            userEmail: UserInfo.Email,
            userName: `${UserInfo.FirstName} ${UserInfo.LastName}`,
            businessName: (businessInfo.name || "").trim(),
            campaignName: promoCard.campaignName,
        }

        console.log("Home trackPromoCards body", body);

        apiPOSTReq(`${environment.uamBaseUrl}/aion/system/trackPromoCards`, {}, body, (err, resp) => {
            try {
                const data = resp;
                console.log("Home trackPromoCards", data);
                if (data.result) {
                    this.setState({ loading: false, isAlertVisible: true })
                    this.dismissPromoCard(promoCard.objectId)
                } else {
                    throw Error(
                        data.error ||
                        data.responseMessage ||
                        "Sorry we had trouble processing your request. Please try again later"
                    );
                }
            } catch (error) {
                console.log("ERRR trackPromoCards", error.stack, resp);
                // ErrorAlert({ description: error.message });
            } finally {
                this.setState({ loading: false })
            }
        });
    };

    render() {
        const { aionStore } = this.props;
        const { promoCard, isAlertVisible, loading } = this.state;
        const { content, logoUrl, ctaInfo } = promoCard || {};

        const userRoles = getUserRoles(aionStore)
        const isCompanyAdmin = userRoles.includes("Company Admin") || userRoles.includes("Owner") || userRoles.includes("Primary Admin")
        const showPromo = ['/banking/home', '/receivables/invoices', '/payables/bills', '/cards/my-cards', '/credit/term-loans/advances', '/credit/ar-credit/advances', 'credit/inventory-loc/advances'].includes(this.props.location.pathname)

        return (
            <>
                {
                    (isCompanyAdmin && showPromo && promoCard) && (
                        <CardContainer
                            style={{
                                position: "fixed",
                                right: "24px",
                                bottom: "24px",
                                margin: 0,
                                padding: 0,
                                zIndex: 1000,
                                transform: "none",
                            }}
                            boxShadow='0px -4px 12px rgba(0, 0, 0, 0.15), 0px 4px 8px rgba(102, 102, 102, 0.08)'
                            width={"326px"}
                        >
                            <Flex end style={{ padding: "16px 16px 0 0" }} gap="8px">
                                <Tooltip placement="bottom" title='Dismiss for now' arrowPointAtCenter={false}>
                                    <ImageButton src={Minimize} onClick={() => this.dismissPromoCard(promoCard.objectId, true)} />
                                </Tooltip>
                                {/* <Tooltip placement="bottom" title='Close' arrowPointAtCenter={false}>
                                    <ImageButton src={ModalClose} onClick={() => this.dismissPromoCard(promoCard.objectId)} />
                                </Tooltip> */}
                            </Flex>
                            <FlexColumn start center style={{ padding: "0 24px 8px" }}>
                                {logoUrl && <Flex centerHorizontally gap="16px">
                                    {/* <Image
                                        src={Aion}
                                        width="64px"
                                        noHeight
                                        style={{ marginTop: 12 }}
                                    />
                                    <Text color="#8181A0" size="28px">
                                        +
                                    </Text> */}
                                    <Image src={logoUrl} width="80px" noHeight />
                                </Flex>}
                                <Text center color="#4F4F78" margin="16px 0 0">
                                    <div dangerouslySetInnerHTML={{ __html: content }}></div>
                                </Text>
                            </FlexColumn>
                            <div style={{ height: 1, width: "100%", background: "#E6E6EC" }}></div>
                            <FlexColumn start center style={{ padding: "16px 24px", height: 64 }}>
                                {ctaInfo?.type === "URL" && (
                                    <StyledExtLink
                                        target="_blank"
                                        href={ctaInfo?.value}
                                        style={{ textDecoration: "underline" }}
                                    >
                                        {ctaInfo?.text ? ctaInfo?.text : "Click here"}
                                    </StyledExtLink>
                                )}
                                {ctaInfo?.type === "YesNo" && (
                                    <Flex fullWidth between>
                                        <Flex grow center fullHeight>
                                            <TextButton
                                                text="Not interested"
                                                onClick={() => this.dismissPromoCard(promoCard.objectId)}
                                            />
                                        </Flex>
                                        <Button loading={loading} solid text="I'm interested" onClick={() => this.trackPromoCards()} />
                                    </Flex>
                                )}
                                {ctaInfo?.type === "Text" && (
                                    <Flex fullWidth center gap="4px">
                                        <Text>Interested? Email us at</Text>
                                        <StyledExtLink
                                            target="_blank"
                                            href="mailto:contact@aionfi.com"
                                            style={{ textDecoration: "underline" }}
                                        >
                                            contact@aionfi.com
                                        </StyledExtLink>
                                    </Flex>
                                )}
                            </FlexColumn>
                        </CardContainer>
                    )}

                <AlertModal
                    visible={isAlertVisible}
                    title="Thank you for your interest!"
                    description={`We'll reach out to you soon`}
                    buttonTitle="Okay"
                    onConfirm={() => {
                        this.setState({ isAlertVisible: false });
                    }}
                    imgSrc={ThumbsUp}
                    imgHeight="80px"
                    imgWidth="80px"
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        aionStore: state.aionAppReducer,
        userDefaults: state.userDefaultsReducer,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PromoModal))